
namespace TabAurous.Inventory {

    @Serenity.Decorators.registerClass()
    export class MixingGrid extends Serenity.EntityGrid<MixingRow, any> {
        protected getColumnsKey() { return 'Inventory.Mixing'; }
        protected getDialogType() { return MixingDialog; }
        protected getIdProperty() { return MixingRow.idProperty; }
        protected getInsertPermission() { return MixingRow.insertPermission; }
        protected getLocalTextPrefix() { return MixingRow.localTextPrefix; }
        protected getService() { return MixingService.baseUrl; }
        private rowSelection: Serenity.GridRowSelectionMixin;
        private autoSize;
        constructor(container: JQuery) {
            super(container);
        }
        protected addButtonClick() {

            let now = new Date();
            var voucherNo = FormatHelper.GetVoucherNo(74);
            var userDefinition = Q.Authorization.userDefinition;
            var autoposting = OMS.VoucherMasterRow.getLookup().itemById[74].AutoPosting;

            this.editItem(<MixingRow>{
                VoucherNo: voucherNo,
                TransDate: now.toDateString(),
                Line_No: 0,
                CompanyId: userDefinition.CompanyId,
                FinancialYearId: userDefinition.FinancialYearId,
                UserId: userDefinition.UserId,
                CurrencyId: userDefinition.CurrencyId,
                VoucherTypeId: 74,
                AutoPosting: autoposting

            });
        }
        protected createSlickGrid(): Slick.Grid {
            let grid = super.createSlickGrid();
            this.autoSize = new Slick.AutoColumnSize();
            grid.registerPlugin(this.autoSize);


            return grid;
        }
        protected createToolbarExtensions() {
            super.createToolbarExtensions();
            this.rowSelection = new Serenity.GridRowSelectionMixin(this);
        }


        protected markupReady() {
            super.markupReady();
            if (this.autoSize != null) {
                this.autoSize.resizeAllColumns();
            }
        }
    }
}